import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { setGlobalErrorHandler } from '@/services/queryClient';

type ToastVariant = 'success' | 'error' | 'warning' | 'info';

interface ToastItem { id: number; message: string; variant: ToastVariant }

interface ToastCtx {
  show: (message: string, variant?: ToastVariant) => void;
}

const ToastContext = createContext<ToastCtx | null>(null);

export function ToastProvider({ children }: { children: React.ReactNode }): React.JSX.Element {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const show = useCallback((message: string, variant: ToastVariant = 'success') => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, variant }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 4000);
  }, []);

  // Connetti il handler errori globale del QueryClient
  useEffect(() => {
    setGlobalErrorHandler((msg) => show(msg, 'error'));
  }, [show]);

  return (
    <ToastContext.Provider value={{ show }}>
      {children}
      <div className="toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`toast ${t.variant === 'success' ? '' : t.variant}`}>
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast(): ToastCtx {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast deve essere usato dentro ToastProvider');
  return ctx;
}
